import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MediationProcess from './mediation-process-model'
import {
  CreateMediationProcessAsync,
  DeleteMediationProcessAsync,
  LoadMediationProcesssAsync,
} from './mediationProcess-thunk'
const initialState: mediationProcessSliceState = {
  mediationProcess: [],
  selected_mediationProcess: '',
  is_loading_mediationProcess: false,
  is_creating_mediationProcess: false,
  is_deleting_mediationProcess: false,
}
export interface mediationProcessSliceState {
  mediationProcess: MediationProcess[]
  selected_mediationProcess?: string
  is_loading_mediationProcess: boolean
  is_creating_mediationProcess: boolean
  is_deleting_mediationProcess: boolean
}
export const mediationProcessSlice = createSlice({
  name: 'mediationProcess',
  initialState,
  reducers: {
    setSelectedmediationProcess: (state, action) => {
      state.selected_mediationProcess = action.payload
    },
    clearStatemediationProcess: (state) => {
      state.mediationProcess = []
      state.is_loading_mediationProcess = false
      state.is_creating_mediationProcess = false
      state.is_deleting_mediationProcess = false
    },
    mergemediationProcess: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_mediationProcess = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.mediationProcess = merge(state.mediationProcess, payload) as any
        }
      }
    },

    add_mediationProcess: (state, action) => {
      if (action.payload) {
        state.mediationProcess = [...state.mediationProcess, action.payload]
      }
    },
    set_mediationProcess: (state, action) => {
      let { key, value, id } = action.payload
      state.mediationProcess = state.mediationProcess.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMediationProcesssAsync.pending, (state) => {
      state.is_loading_mediationProcess = true
    })
    builder.addCase(LoadMediationProcesssAsync.fulfilled, (state, action) => {
      state.is_loading_mediationProcess = false
      if (action.payload) {
        state.mediationProcess = action.payload
      }
    })
    builder.addCase(LoadMediationProcesssAsync.rejected, (state) => {
      state.is_loading_mediationProcess = false
    })
    builder.addCase(CreateMediationProcessAsync.pending, (state) => {
      state.is_creating_mediationProcess = true
    })
    builder.addCase(CreateMediationProcessAsync.fulfilled, (state) => {
      state.is_creating_mediationProcess = false
    })
    builder.addCase(CreateMediationProcessAsync.rejected, (state) => {
      state.is_creating_mediationProcess = false
    })
    builder.addCase(DeleteMediationProcessAsync.pending, (state) => {
      state.is_deleting_mediationProcess = true
    })
    builder.addCase(DeleteMediationProcessAsync.fulfilled, (state, action) => {
      state.is_deleting_mediationProcess = false
      if (state.mediationProcess) {
        state.mediationProcess = state.mediationProcess.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteMediationProcessAsync.rejected, (state) => {
      state.is_deleting_mediationProcess = false
    })
  },
})

export const {
  clearStatemediationProcess,
  setSelectedmediationProcess,
  set_mediationProcess,
  mergemediationProcess,
  add_mediationProcess,
} = mediationProcessSlice.actions

export const get_mediationProcess =
  (id?: string) =>
  (state: {
    mediationProcess: {
      mediationProcess: MediationProcess[]
    }
  }): MediationProcess | null => {
    let temp = state?.mediationProcess?.mediationProcess?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.mediationProcess?.mediationProcess[0] || null
  }
export const get_selected_mediationProcess = (state: {
  mediationProcess: mediationProcessSliceState
}): MediationProcess | null => {
  let id = state?.mediationProcess?.selected_mediationProcess
  let temp = state?.mediationProcess?.mediationProcess?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_mediationProcess = (state: {
  mediationProcess: {
    mediationProcess: MediationProcess[]
  }
}): MediationProcess[] => {
  let temp = state?.mediationProcess?.mediationProcess
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_mediationProcess_busy = (state: {
  mediationProcess: mediationProcessSliceState
}) => {
  return (
    state?.mediationProcess.is_deleting_mediationProcess ||
    state?.mediationProcess.is_loading_mediationProcess ||
    state?.mediationProcess.is_creating_mediationProcess
  )
}
export const is_deleting_mediationProcess_busy = (state: {
  mediationProcess: mediationProcessSliceState
}) => {
  return state?.mediationProcess.is_deleting_mediationProcess
}
export const is_loading_mediationProcess_busy = (state: {
  mediationProcess: mediationProcessSliceState
}) => {
  return state?.mediationProcess.is_loading_mediationProcess
}
export const is_creating_mediationProcess_busy = (state: {
  mediationProcess: mediationProcessSliceState
}) => {
  return state?.mediationProcess.is_creating_mediationProcess
}

export default mediationProcessSlice.reducer
